import React from 'react'
import { InterviewHandlersContext } from 'components/modules/interview/context'
import { INTERVIEW_STEPS } from 'ducks/router'
import { useContext } from 'hooks'

// NOTE: hook that handles toggling edit mode
export const useEditMode = ({ handleChangeStep }) => {
  const [isEditMode, setIsEditMode] = React.useState(false)

  const toggleEditMode = React.useCallback(() => {
    if (!isEditMode) {
      handleChangeStep(INTERVIEW_STEPS.SUMMARY)
    }

    setIsEditMode(!isEditMode)
  }, [setIsEditMode, isEditMode])

  return {
    state: { isEditMode },
    handlers: { toggleEditMode },
  }
}
